import { FaqItem } from "@/components/screen/global-components/faq/FaqStack";

export const faqItems: FaqItem[] = [
  {
    id: "process",
    title: "How does the translation process work?",
    description: [
      "The typical cost for translation services starts at just $0.10 per word with Languex, while some companies charge from $0.15 to 0.35 per word. This price can vary, however, based on factors like language pairs, the complexity of the content, and turnaround time. For a customized estimate that fits your needs, we recommend using our Translation Cost Calculator or contacting our team for an official quote.",
    ],
    linkText: "Learn more",
    link: "/pricing",
  },
  {
    id: "standard",
    title: "What is a standard translation?",
    description:
      "A standard translation is a professional translation without certification or notarization.",
  },
  {
    id: "cost",
    title: "How much does a translation cost?",
    description:
      "Prices start from $0.10/word. Final cost depends on content, language, and urgency.",
  },
  {
    id: "documents",
    title: "What types of documents do you translate?",
    description: "Legal, medical, academic, immigration, and more.",
  },
  {
    id: "rush",
    title: "Do you offer expedited or rush services?",
    description:
      "Yes, expedited services are available depending on document type and size.",
  },
  {
    id: "apostille",
    title: "Can you provide an apostille?",
    description:
      "Yes, apostille assistance is available. Contact us to discuss options.",
  },
  {
    id: "security",
    title: "How do you ensure confidentiality and data security?",
    description:
      "We follow strict confidentiality protocols and use secure data handling.",
  },
  {
    id: "certified",
    title: "What is a certified translation?",
    description:
      "A certified translation includes a signed statement affirming the translation is accurate and complete.",
  },
  {
    id: "duration",
    title: "How long does the translation take?",
    description: "Most translations are delivered within 24-48 hours.",
  },
  {
    id: "languages",
    title: "What languages do you translate?",
    description:
      "We support 65+ languages including Spanish, French, German, Chinese, Arabic.",
  },
  {
    id: "translator",
    title: "Who will translate my documents?",
    description:
      "Professional translators with subject-matter expertise handle your documents.",
  },
  {
    id: "notarization",
    title: "Do you offer notarization services?",
    description: "Yes, notarized translations are available for official use.",
  },
  {
    id: "physical-copy",
    title: "Can you send me a physical copy of my translation?",
    description: "Yes, printed and mailed copies are available upon request.",
  },
  {
    id: "accepted",
    title: "Will my translation be accepted?",
    description:
      "Our certified translations are accepted by USCIS and many other institutions.",
  },
];
